import React, { useEffect, useState } from "react";
import { Button, Card, Container, Grow, List, ListItem, ListItemIcon, ListItemText, ListSubheader, MenuItem, OutlinedInput, Select, Switch } from "@mui/material";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";
import { getNotificationSubscriptionOfUser, deleteSubscription, setSubscribeNotification, getNotificationLanguages, setNotificationLanguage } from "../../store/actions/notificationActions";
import { useDispatch, useSelector } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import { useSnackbar } from "notistack";
import { useTheme } from "@mui/material/styles";
import { appVersion } from "../../utils/config";
import { VscVersions } from "react-icons/vsc";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ss = sessionStorage;
ss.setItem("subscribedUpdate", false);

const Settings = (props) => {
    const theme = useTheme();
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    const [subscribedStatus, setSubscribedStatus] = useState(false);
    const [subscribeId, setSubscribeId] = useState(0);
    const [notificationLanguageList, setNotificationLanguageList] = useState([]);
    const [notificationLanguageId, setNotificationLanguageId] = useState(1);
    const [snackbarFromOverview, setSnackbarFromOverview] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();

    useEffect(() => {
        if (!props.fromOverview) {
            dispatch(getNotificationLanguages());
        }
        getNotificationSubscriptionOfUserHandler();
    }, []);

    const { subscribed, notificationLanguages, userNotificationLanguage } = useSelector(({ notification }) => notification);

    const isMobile = {
        iOS() {
          return /iPhone|iPad|iPod/i.test(navigator.userAgent);
        },
      };

    useEffect(() => {
        if (subscribed.resultObject) {
            // subscribed is not null
            setSubscribedStatus(true);
            setSubscribeId(subscribed.resultObject.id);
            setNotificationLanguageId(subscribed.resultObject.languageId ?? 1);
            subscribed.resultObject = null;
            if (props.fromOverview && ss.getItem("subscribedUpdate") === "false" && !isMobile.iOS()) {
                // in overview page and after login process
                navigator.serviceWorker.ready.then((sw) => {
                    sw.pushManager.getSubscription().then((subscription) => {
                        if (subscription) {
                            const payload = {
                                id: subscribeId,
                            };
                            subscription.unsubscribe().then(() => {
                                dispatch(deleteSubscription(payload, props.fromOverview));
                                setSubscribedStatus(false);
                            });
                        }
                    });
                });
                OpenSubscriptionHandler();
                ss.setItem("subscribedUpdate", true);
                setSnackbarFromOverview(false);
            }
        }
        if (subscribed.resultObject === null) {
            // subscribtion is null
            if (props.fromOverview && ss.getItem("subscribedUpdate") === "false" && !isMobile.iOS()) {
                // in overview page and after login process
                setSnackbarFromOverview(true);
                ss.setItem("subscribedUpdate", true);
            }
        }
    }, [subscribed]);

    useEffect(() => {
        if (notificationLanguages.length > 0) {
            setNotificationLanguageList(notificationLanguages);
        }
    }, [notificationLanguages]);

    useEffect(() => {
        if (userNotificationLanguage?.resultObject) {
            setNotificationLanguageId(userNotificationLanguage.resultObject.languageId);
        }
    }, [userNotificationLanguage]);

    const getNotificationSubscriptionOfUserHandler = () => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        if (oktaToken && oktaToken.idToken) {
            const userName = oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "");
            dispatch(getNotificationSubscriptionOfUser(userName));
        }
    };

    const showSnackMessage = () => {
        if (!getConsentGranted()) {
            enqueueSnackbar(t("NotificationsBrowserSettings"), { variant: "info" });
            getNotificationSubscriptionOfUserHandler();
        }
    };

    const deleteSubscriptionHandler = () => {
        const payload = {
            id: subscribeId,
        };
        showSnackMessage();
        if (subscribedStatus) {
            navigator.serviceWorker.ready
                .then((sw) => {
                    sw.pushManager
                        .getSubscription()
                        .then((subscription) => {
                            if (subscription) {
                                subscription
                                    .unsubscribe()
                                    .then(() => {
                                        dispatch(deleteSubscription(payload));
                                        setSubscribedStatus(false);
                                    })
                                    .catch((err) => {
                                    });
                            } else {
                                dispatch(deleteSubscription(payload));
                                setSubscribedStatus(false);
                            }
                        })
                        .catch((err) => {
                        });
                })
                .catch((err) => {
                });
        }
    };

    const OpenSubscriptionHandler = () => {
        initNotifications(process.env.REACT_APP_PUSH_SERVER_PUBLIC_KEY);
        showSnackMessage();
    };

    const isPushNotificationSupported = () => {
        return "serviceWorker" in navigator && "PushManager" in window;
    };

    const askUserPermission = () => {
        return new Promise(function (resolve, reject) {
            const permissionResult = Notification.requestPermission(function (result) {
                resolve(result);
            });
            if (permissionResult) {
                permissionResult.then(resolve, reject);
            }
        });
    };

    const getConsentGranted = () => {
        return Notification.permission === "granted";
    };

    const sendSubscriptionToServer = (subscription) => {
        dispatch(setSubscribeNotification(subscription, props.fromOverview));
        getNotificationSubscriptionOfUserHandler();
    };

    const initNotifications = (pushServerPublicKey) => {
        if (isPushNotificationSupported()) {
            if (!subscribedStatus || (subscribedStatus && props.fromOverview)) {
                askUserPermission().then((_d) => {
                    // check if service worker ready
                    navigator.serviceWorker.ready
                        .then((sw) => {
                            // check if notifications are allowed
                            if (getConsentGranted()) {
                                // get user subscription
                                sw.pushManager.getSubscription().then((userSubscription) => {
                                    // if user is not subscribed
                                    if (!userSubscription || (userSubscription && props.fromOverview)) {
                                        // create notification subscription
                                        sw.pushManager
                                            .subscribe({
                                                userVisibleOnly: true,
                                                applicationServerKey: pushServerPublicKey,
                                            })
                                            .then((subscription) => {
                                                sendSubscriptionToServer(subscription);
                                                setSubscribedStatus(true);
                                            })
                                            .catch((err) => {});
                                    } else {
                                        setSubscribedStatus(true);
                                    }
                                });
                            }
                        })
                        .catch((err) => {});
                });
            }
        } else {
            if (!subscribedStatus) {
                askUserPermission().then((_d) => {
                    // check if service worker ready
                    navigator.serviceWorker.ready
                        .then((sw) => {
                            // check if notifications are allowed
                            if (getConsentGranted()) {
                                // get user subscription
                                sw.pushManager.getSubscription().then((userSubscription) => {
                                    // if user is not subscribed
                                    if (!userSubscription) {
                                        // create notification subscription
                                        sw.pushManager
                                            .subscribe({
                                                userVisibleOnly: true,
                                                applicationServerKey: pushServerPublicKey,
                                            })
                                            .then((subscription) => {
                                                sendSubscriptionToServer(subscription);
                                                setSubscribedStatus(true);
                                            })
                                            .catch((err) => {});
                                    } else {
                                        setSubscribedStatus(true);
                                    }
                                });
                            }
                        })
                        .catch((err) => {});
                });
            }
        }
    };

    const handleUserNotificationLanguageChange = (event) => {
        dispatch(setNotificationLanguage(event.target.value));
    };

    const redirectToPage = () => {
        const tabValue = 1;
        history.push("/profile", {tabValue});
    };

    const handleClose = () => {
        setSnackbarFromOverview(false);
    };

    return !props.fromOverview ? (
        <div>
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                <Container fixed justify="center" maxWidth="xs" style={{ marginTop: 20, marginBottom: 20 }}>
                    <Card>
                        <List subheader={<ListSubheader sx={{ backgroundColor: theme.palette.mode === "light" ? "#ccc" : "#282424" }}>{t("Notifications")}</ListSubheader>}>
                            <ListItem>
                                <ListItemIcon>
                                    <NotificationsRoundedIcon />
                                </ListItemIcon>
                                <ListItemText id="switch-list-label-notification" primary={t("Notifications")} />
                                <Switch
                                    checked={subscribedStatus}
                                    onChange={() => {
                                        if (subscribedStatus) {
                                            deleteSubscriptionHandler();
                                        } else {
                                            OpenSubscriptionHandler();
                                        }
                                    }}
                                    name="checkedSubscribe"
                                    inputProps={{ "aria-label": "secondary checkbox" }}
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <LanguageRoundedIcon />
                                </ListItemIcon>
                                <ListItemText id="switch-list-label-bluetooth" primary={t("NotificationLanguage")} />
                                <Select
                                    value={notificationLanguageId}
                                    onChange={handleUserNotificationLanguageChange}
                                    input={<OutlinedInput name="notificationLanguage" id="outlined-language-simple" />}
                                    disabled={!subscribedStatus}
                                >
                                    {notificationLanguageList.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.description}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <VscVersions style={{ width: "20px", height: "20px" }} />
                                </ListItemIcon>
                                <ListItemText id="version" primary={t("Version")} />
                                <label>{appVersion}</label>
                            </ListItem>
                        </List>
                    </Card>
                </Container>
            </Grow>
            <LoadingBackdrop />
        </div>
    ) : //     <Button color="inherit" size="small">
    //     AYARLAR
    // </Button>
    snackbarFromOverview && ss.getItem("subscribedUpdate") ? (
        <Snackbar
            ContentProps={{
                sx: {
                    background: '#ffcc00',
                    color: '#000000',
                },
            }}
            open={snackbarFromOverview}
            autoHideDuration={4000}
            onClose={handleClose}
            message={t("NotificationsDisabled")}
            action={
                <React.Fragment>
                    <Button size="small" aria-label="close" color="inherit" onClick={redirectToPage}>
                        {t("Settings")}
                    </Button>
                </React.Fragment>
            }
        ></Snackbar>
    ) : null;
};

export default Settings;
